import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { truncateFileName } from '@components/Checkout/steps/PhoneNumberStep/utils/phoneNumberStepUtils';
import type { FilePreviewCardProps } from '@components/Checkout/steps/PhoneNumberStep/PhoneNumberStep.types';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export const FilePreviewCard = ({ view, onRemove }: FilePreviewCardProps) => {
  const truncatedName = truncateFileName(view.displayName);

  return (
    <Paper variant="filePreviewCard" elevation={0} sx={{ position: onRemove ? 'relative' : undefined }}>
      {onRemove && (
        <IconButton
          size="small"
          onClick={onRemove}
          sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}
          aria-label={`Remove ${view.displayName}`}
        >
          <DeleteOutlineIcon sx={{ fontSize: '20px' }} />
        </IconButton>
      )}
      <Stack className="FilePreviewCard-thumbnail">
        <img
          src={`https://cdn.simplyask.ai/symphona-cpq/extensions/${view.iconName}.svg`}
          alt={view.iconName}
          style={{ width: '64px', height: '64px', objectFit: 'contain' }}
        />
      </Stack>
      <Stack sx={{ padding: '10px 12px' }}>
        <Typography variant="label.fieldSmall" className="FilePreviewCard-name" title={view.displayName}>
          {truncatedName}
        </Typography>
        {view.dateLabel != null && (
          <Typography className="FilePreviewCard-date">{view.dateLabel}</Typography>
        )}
      </Stack>
    </Paper>
  );
};
